<template>
  <div class="s_bf">
    <p class="p-l-10 p-t-10 p-b-10 fz-15 s_font_b s_bb1_cf4f">任务标题</p>
    <div class="p-l-15 p-r-15">
      <div class="s_flex_bian_c p-t-15 p-b-15 s_bb1_cf4f" v-for="(item,index) in data.data" :key="index">
        <img class="width-50 height-50"  style="object-fit:cover" :src="item.imgUrl?info.picdomain+item.imgUrl:require('@/assets/images/normal.png')" alt="">
        <div class="width58">
          <p class="fz-15 s_c333 m-b-5 s_omit">{{item.name || '任务名称'}}</p>
          <p class="fz-12 s_c999 s_omit2">{{item.describe || '任务描述'}}</p>
        </div>
        <a-button type="primary" size="small">去完成</a-button>
      </div>
    </div>
  </div>
  
</template>
<script>
  import { ref} from "vue";
  import store from "@/store";
export default {
  props: { data: Object },
  name: "task",
  setup(){
      return{
        info: ref(store.state.user.info)
      }
    }
};
</script>
<style>

</style>